import React, { useState, useEffect } from 'react'
import axios from 'axios'
import DisableCommentsToggle from '../../../components/common/DisableCommentsToggle'
import { baseUrl } from '../../../constants/config'

const SettingsLayout = () => {
    const [disableComments, setDisableComments] = useState(false)
    const [loading, setLoading] = useState(true)

    // 🔹 1. Fetch current settings on component mount
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await axios.get(`https://api.meaningfulminute.org/settings/comments`)
                const data = response.data

                // API returns { commentsEnabled: false }
                // The component shows "Disable comments", so we invert it
                setDisableComments(!data.commentsEnabled)
            } catch (error) {
                console.error('Error fetching settings:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchSettings()
    }, [])

    // 🔹 2. Handle toggle change
    const handleToggle = async (checked) => {
        setDisableComments(checked)

        try {
            // API expects { enabled: true/false }
            // We invert because "disable" in UI = "enabled: false"
            const payload = { enabled: !checked }
            await axios.post(`https://api.meaningfulminute.org/settings/comments`, payload)
            console.log('Settings updated:', payload)
        } catch (error) {
            console.error('Error updating settings:', error)
        }
    }

    if (loading) return <div className="p-4">Loading...</div>

    return (
        <div className="p-4">
            <h4 className="mb-3">Comments Settings</h4>
            <DisableCommentsToggle
                disabled={disableComments}
                onChange={handleToggle}
            />
        </div>
    )
}

export default SettingsLayout
